/**
 * Builds the CSV text the backend import endpoints accept (RFC 4180).
 *
 * This is the wire format sent to `/api/v1/<resource>/csv`, not a file a person
 * opens, so there is deliberately no formula-injection sanitising here — that
 * lives in csvExport.ts for downloads.
 */

/** Quote a cell when it contains a delimiter, quote or line break. */
export function csvEscape(value: string): string {
    if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
        return '"' + value.replace(/"/g, '""') + '"';
    }
    return value;
}

function cellToString(value: unknown): string {
    if (value === null || value === undefined) {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
        return String(value);
    }
    // Objects and arrays have no CSV cell form; serialise rather than emit "[object Object]".
    return JSON.stringify(value);
}

/**
 * Serialise rows to CSV text with the given header order. Missing keys become
 * empty cells, so every row has the same width as the header.
 */
export function buildCsvText(headers: readonly string[], rows: readonly Record<string, unknown>[]): string {
    const lines = [headers.map(csvEscape).join(',')];
    for (const row of rows) {
        lines.push(headers.map((h) => csvEscape(cellToString(row[h]))).join(','));
    }
    return lines.join('\n') + '\n';
}
